import React, { useState, useEffect, useRef } from "react";
import {
  View,
  Image,
  SafeAreaView,
  Text,
  Platform,
  TouchableOpacity,
  Linking,
  useWindowDimensions,
} from "react-native";
import StyleSheet from "react-native-media-query";
import { ScreenNameList, AlertType, getCarrierName, getCompanyName } from "@lib/utilities/Constants";
import MobileAlertView from "../common/MobileAlertView";
import {
  CALL_ICON,
  EMAIL_ICON,
  ERROR_ICON,
  REFRESH_ICON,
  SUCCESS_ICON,
} from "../../resources/IMAGES";
import { theme } from "../../theme/theme";
import { customerCareEmail, customerCarePhone, labelText, messages } from "../../resources/strings";
import { clearSessionAndLogout } from "@lib/utilities/AuthHelper";
import { useAuth0 } from "@auth0/auth0-react";
import { useNavigation } from "@react-navigation/native";
import { displayPhoneFormatter, getFormattedLabelText } from "@lib/utilities/Formatters";
import ContactCard, { CardType } from "../ContactCard/ContactCard";
import { useAppSelector } from "@lib";
import { getUserEmail } from "@lib/utilities/HelperFunctions";
import { isTablet } from "react-native-device-info";

const CustomAlert = ({
  data,
  onEndTimer,
  onEndLogoutTimer,
  onReloadPress,
  initialValue = data?.message?.includes(messages.error.pdfError) ? 500 : 300,
}: any) => {
  const [time, setTime] = useState(initialValue);
  const [showReload, setShowReload] = useState(false);
  const [alertType, setAlertType] = useState(AlertType.noAlert);
  const [message, setMessage] = useState(data.message);
  const [subMessage, setSubMessage] = useState("");
  const [email, setEmail] = useState<string | null>(null);
  const timerRef = useRef(initialValue);
  const user = useAppSelector((state) => state.userReducer);
  const { screenName, color: textColor, showAsAlert } = data;
  const { logout } = useAuth0();
  const navigation = useNavigation();
  const {width, height} = useWindowDimensions()

  const startCountdown = () => {
    const timer = setInterval(() => {
      timerRef.current -= 1;
      if (timerRef.current < 0) {
        clearInterval(timer);
        if (message === messages.error.resetPasswordLogout)
          onEndLogoutTimer?.();
        else onEndTimer?.();
      } else {
        setTime(timerRef.current);
      }
    }, 10);
    return () => clearInterval(timer);
  };
  const getEmail = async () => {
    const emailValue = await getUserEmail();
    setEmail(emailValue);
  };

  const showBottomToast = (_message: string) => {
    setAlertType(AlertType.bottomToast);
    const noReloadMessages = [
      messages.error.documentDownloadFailed,
      messages.error.resetPasswordLogout,
      messages.error.currentPasswordDidNotMatch,
      messages.error.noDataFound,
      messages.error.noPolicyFound,
      messages.error.noNotificationFound,
      messages.error.deleteAccountMessage,
      messages.error.somthingWrong,
      messages.error.pdfError,
    ];
    startCountdown();
    if (
      screenName === ScreenNameList.register ||
      noReloadMessages.includes(_message)
    ) {
      setShowReload(false);
    } else {
      setShowReload(false);
    }
    startCountdown();
  };

  const configureMessage = () => {
    if (message === messages.error.youAreOffline) {
      setMessage(messages.error.youAreOffline);
      setSubMessage(messages.error.noInternet);
      setAlertType(AlertType.centerAlert);
    } else {
      setMessage(message);
      setAlertType(AlertType.centerMessage);
      if (message === messages.error.deleteAccountMessage) {
        showBottomToast(message);
      } else if (
        message === messages.error.resetPasswordLogout ||
        message === messages.error.sessionExpired
      ) {
        setAlertType(AlertType.centerAlert);
        setSubMessage(messages.error.resetPasswordLogout);
      } else if (message === messages.error.noDataFound) {
        setSubMessage(messages.error.thereIsNoData);
      } else if (message === messages.error.noPolicyFound) {
        setSubMessage(messages.error.thereAreNoPoliciesAssociated);
      } else if (message === messages.error.noNotificationFound) {
        setSubMessage(messages.error.noNotificationSubMsg);
      } else {
        showBottomToast(message);
      }
    }
  };


  useEffect(() => {
    configureMessage();
  }, [message, screenName, showAsAlert]);

  useEffect(() => {
    if (
      message == messages.error.resetPasswordLogout ||
      message == messages.error.sessionExpired
    ) {
      setTimeout(() => {
        clearSessionAndLogout(navigation, logout);
      }, 2000);
    }
    getEmail();
  }, []);

  const buttonsData = {
    phone: {
      icon: CALL_ICON,
      type: CardType.Phone,
      title: labelText.commonLabels.callUs,
      content: displayPhoneFormatter(customerCarePhone),
      onPress: () => Linking.openURL(`tel:${customerCarePhone}`),
      isFaded: customerCarePhone ? false : true,
    },
    mail: {
      icon: EMAIL_ICON,
      type: CardType.Email,
      title: labelText.commonLabels.emailUs,
      content: customerCareEmail,
      onPress: () => Linking.openURL(`mailto:${customerCareEmail}`),
      isFaded: customerCareEmail ? false : true,
    },
  };

  const getTextColor = () => {
    return { color: textColor || theme.colors.white };
  };

  const brandName = getCompanyName()
  const brandNameCaps = getCompanyName()?.toUpperCase()

  if (
    alertType === AlertType.centerAlert ||
    subMessage === messages.error.resetPasswordLogout
  ) {
    return (
      <SafeAreaView
        style={[styles.container, styles.background]}
        dataSet={{ media: ids.container }}
      >
        <View style={[styles.alertBox]}>
          <MobileAlertView
            title={
              message === messages.error.resetPasswordLogout
                ? messages.error.sessionExpired
                : message
            }
            message={subMessage}
            closeAlert={() =>
              message === messages.error.resetPasswordLogout ||
              message === messages.error.sessionExpired
                ? onEndLogoutTimer?.()
                : onEndTimer?.()
            }
          />
        </View>
      </SafeAreaView>
    );
  }

  if (alertType === AlertType.centerMessage) {
    return (
      <SafeAreaView style={[styles.container, styles.centerAlert]}>
        <Text style={[styles.messageText, getTextColor()]}>{message}</Text>
        {message === messages.error.noPolicyFound ? (
          <>
            <Text
              style={[
                styles.subMessageText,
                getTextColor(),
                message === messages.error.noPolicyFound && styles.noPolicy,
              ]}
              dataSet={{ media: ids.noPolicy }}
            >{`If you have a `}{
              getCarrierName()=="hcpci"?"Homeowners Choice" :
              getCarrierName()=="core"?brandNameCaps:getFormattedLabelText(brandName)
            } policy, please ensure that the email <Text style={styles.emailTxt}>{email}</Text>{` is associated with the policy. You may also contact Customer Service for any questions.`}
            </Text>
            <View
              style={[styles.contactButtonsContainer, 
                isTablet()&&(width>height?styles.flexRow:styles.flexCol)
              ]}
              dataSet={{ media: ids.contactButtonsContainer }}
            >
              {Object.values(buttonsData).map((card, index) => (
                <ContactCard
                  key={index}
                  type={card.type}
                  icon={card.icon}
                  title={card.title}
                  content={card.content}
                  onPress={card.onPress}
                  isFaded={card.isFaded}
                  responsive
                />
              ))}
            </View>
          </>
        ) : (
          <Text style={[styles.subMessageText, getTextColor()]}>
            {subMessage}
          </Text>
        )}
      </SafeAreaView>
    );
  }

  if (alertType === AlertType.bottomToast) {
    return (
      <View style={styles.bottomToast}>
        {message == messages.success.downloadSuccess ? (
          <Image style={styles.errorIcon} source={SUCCESS_ICON} />
        ) : (
          <Image style={styles.errorIcon} source={ERROR_ICON} />
        )}
        <Text style={[styles.notificationText, getTextColor()]}>{message}</Text>
        {showReload && Platform.OS === "web" && (
          <TouchableOpacity onPress={onReloadPress}>
            <Image style={styles.refresh} source={REFRESH_ICON} />
          </TouchableOpacity>
        )}
      </View>
    );
  }

  return null;
};

export default CustomAlert;
const { ids, styles } = StyleSheet.create({
  container: {
    position: "absolute",

    justifyContent: "center",
    alignItems: "center",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  },
  flexRow: {flexDirection:"row"},
  flexCol: {flexDirection:"column"},
  caps: {
    textTransform: "uppercase",
  },
  emailTxt: {
    fontWeight:theme.fontweight.semiBold
  },
  contactButtonsContainer: {
    flexDirection: "row",
    gap: 20,
    maxWidth: "90%",
    marginTop: theme.margin.xlg,

    "@media (max-width: 850px)": {
      gap: 20,
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
    },
  },
  noPolicy: {
    maxWidth: "55%",
    "@media (max-width: 768px)": {
      maxWidth: "90%",
    },
  },
  centerAlert: {
    paddingHorizontal: theme.spacing.reg,
    marginTop: 50, // temp
    top: "10%",
  },
  background: {
    backgroundColor: theme.colors.loaderBg,
  },
  alertBox: {
    padding: theme.spacing.sm,
    borderRadius: theme.radius.mmd,
    backgroundColor: theme.colors.loaderBg,
  },
  messageText: {
    fontFamily: theme.fontFamily.robotoSlabBold,

    fontSize: theme.fontsize.mmd,
    textAlign: "center",
    marginBottom: theme.margin.sm,
  },
  subMessageText: {
    fontFamily: theme.fontFamily.robotoRegular,

    textAlign: "center",
    fontSize: theme.fontsize.cs,
  },
  bottomToast: {
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "row",
    backgroundColor: theme.colors.alertMessage,
    borderRadius: theme.radius.xxs,
    paddingHorizontal: theme.spacing.reg,
    height: theme.spacing.xxl4,
    marginHorizontal: "auto",
    bottom: theme.spacing.xxl3,
    position: "absolute",
    alignSelf: "center",
  },
  errorIcon: {
    width: theme.spacing.lg,
    height: theme.spacing.lg,
    marginRight: theme.margin.md,
  },
  refresh: {
    width: theme.spacing.lg,
    height: theme.spacing.lg,
    marginLeft: theme.margin.md,
  },
  notificationText: {
    fontFamily: theme.fontFamily.robotoSlabBold,
  },
});
